export class Empresa{
	constructor(
		public id: number, 
		public rfc: string,
		public denominacion: string,
		public nombre_establecimiento: string,
		public habitaciones: number,
		public calle: string,
		public no_interior: number,
		public no_exterior: number,
		public cp: number,
		public colonia: string,
		public licencia_funcionamiento: string

	){}
}